import React, { Component, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Button,
  Modal,
  Row,
  Col,
  Form,
  Container,
  Badge,
  ButtonGroup,
} from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import axios from "axios";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css"; // Import Sun Editor's CSS File
import Select from "react-select";

// Databale

import { FilterMatchMode } from "primereact/api";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Toolbar } from "primereact/toolbar";
import { Toast } from "primereact/toast";
import "primeicons/primeicons.css";

import "../../asset/style.css";

import { APIKEY } from "../../Config/Config";
const btnStyle = {
  height: "38px",
  justifyContent: "center",
  marginLeft: "4px",
};
class MarketPlace extends Component {
  constructor() {
    super();
    this.editor = React.createRef();
    this.state = {
      Categorydata: [],
      SubCategorydata: [],
      Divisiondata: [],
      MarketPlacedata: [],
      ID: "",
      categoryValue: [],
      subCategoryValue: [],
      divisionValue: [],
      Category: "",
      SubCategory: "",
      Division: "",
      ProductName: "",
      MarketURL: "",
      ProductLogo: "",
      CompanyName: "",
      ProductTagLine: "",
      ProductSummaryTitle: "Product Summary",
      ProductSummary: "",
      ProductDetailsTitle: "Product Details",
      ProductDetails: "",
      IsFeatured: "",
      IsRecommended: "",
      ProductWebsiteLink: "",
      TagTitle: "Tag",
      ProductTags: "",
      ProductVideoLinks: "",
      ProductHighlightsTitle: "Product Highlights",
      ProductHighlights1: "",
      ProductHighlights2: "",
      ProductHighlights3: "",
      SeoMetaTitle: "",
      SeoMetaDescription: "",
      SeoMetaTags: "",
      KeyInfoTitle: "Key Info",
      MobileApp: "",
      FreeTrialPeriod: "",
      EligibleforSingapore: "",
      FreeVersion: "",
      MinPriceUserPerMonth: "",
      ContactName: "",
      Designation: "",
      Email: "",
      ContactNumber: "",
      ContactMobileNumber: "",
      HeadquarterAddress: "",
      State: "",
      City: "",
      Country: "",
      Pincode: "",
      AdditionalContactNumber: "",
      AdditionalBranchAddress: "",
      ProductImages: "",
      ProductBrochure: "",
      SocialShareImage: "",
      file: [],
      status: null,
      //   Modal
      show: false,
      fullscreen: true,
      Deletemodal: "",
      Statusmodal: "",
      // datatable
      filters1: null,
      globalFilterValue1: "",
      loading1: true,
      balanceFrozen: true,
    };
    this.handleChangeProductDetails =
      this.handleChangeProductDetails.bind(this);
    this.onGlobalFilterChange1 = this.onGlobalFilterChange1.bind(this);
    this.activityBodyTemplate = this.activityBodyTemplate.bind(this);
    this.BlogStatus = this.BlogStatus.bind(this);
    this.leftToolbarTemplate = this.leftToolbarTemplate.bind(this);
    this.rightToolbarTemplate = this.rightToolbarTemplate.bind(this);
    this.exportCSV = this.exportCSV.bind(this);
    this.onChangeMarketplace = this.onChangeMarketplace.bind(this);
  }

  componentDidMount() {
    this.getAll();
    this.getAllCategorys();
    this.initFilters1();
  }

  getAll() {
    axios
      .get(`${APIKEY}/MarketPlace/admin`)
      .then((res) => {
        this.setState({
          MarketPlacedata: res.data,
          loading1: false,
        });
        console.log("data", res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  //   Category Get All List
  getAllCategorys() {
    axios
      .get(`${APIKEY}/Categories/`)
      .then((res) => {
        console.log("nnn", res.data);
        const CATGET = [];
        if (res.data) {
          res.data.map((cate) => {
            const data = {
              value: cate._id,
              label: cate.CategoryName,
            };
            CATGET.push(data);
          });
        }
        this.setState({
          Categorydata: CATGET,
        });
        console.log("data", res.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }
  // Datatable Start
  onGlobalFilterChange1(e) {
    const value = e.target.value;
    let filters1 = { ...this.state.filters1 };
    filters1["global"].value = value;

    this.setState({ filters1, globalFilterValue1: value });
  }
  initFilters1() {
    this.setState({
      filters1: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      globalFilterValue1: "",
    });
  }

  renderHeader1() {
    return (
      <div className="flex justify-content-between">
        {/* <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={this.clearFilter1} /> */}
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            value={this.state.globalFilterValue1}
            onChange={this.onGlobalFilterChange1}
            placeholder="Keyword Search"
          />
        </span>
      </div>
    );
  }

  BlogStatus(rowData) {
    return (
      <>
        <div className="">
          {rowData.isActive ? (
            <>
              <h6>
                <Badge bg="success">Active</Badge>
              </h6>
            </>
          ) : (
            <>
              <h6>
                <Badge bg="danger">InActive</Badge>
              </h6>
            </>
          )}
        </div>
      </>
    );
  }
  activityBodyTemplate(rowData) {
    return (
      <>
        <div className="">
          <ButtonGroup aria-label="Basic example">
            <Button
              variant="primary"
              size="sm"
              data-toggle="tooltip"
              data-placement="left"
              title="Tooltip on left"
              onClick={() => this.EditClickButton(rowData)}
            >
              <Icon.PencilFill />
            </Button>{" "}
            <Button
              variant="info"
              size="sm"
              onClick={() =>
                this.StatusClickButton(rowData._id, rowData.isActive)
              }
            >
              <Icon.Check2Circle />
            </Button>{" "}
            {/* <Button   variant="success" onClick={()=>this.StatusClickButton(rowData._id)} ><Icon.EyeFill /></Button>{" "} */}
            <Button
              variant="danger"
              size="sm"
              onClick={() => this.DeleteClickButton(rowData._id)}
            >
              <Icon.TrashFill />
            </Button>{" "}
          </ButtonGroup>
        </div>
      </>
    );
  }
  exportCSV() {
    this.dt.exportCSV();
  }

  leftToolbarTemplate() {
    return (
      <React.Fragment>
        {/* <Button label="Delete" icon="pi pi-trash" className="p-button-danger" onClick={this.confirmDeleteSelected} disabled={!this.state.selectedProducts || !this.state.selectedProducts.length} /> */}
        <div>
          <h3>MarketPlace</h3>
        </div>
      </React.Fragment>
    );
  }

  rightToolbarTemplate() {
    return (
      <React.Fragment>
        {/* <FileUpload mode="basic" name="demo[]" auto url="https://primefaces.org/primereact/showcase/upload.php" accept=".csv" chooseLabel="Import" className="mr-2 inline-block" onUpload={this.importCSV} /> */}
        <Button
          label="Export"
          variant="warning"
          className=" bg-warning me-2 btn text-white"
          onClick={this.exportCSV}
        >
          Export
        </Button>
        <Button
          label="New"
          icon="pi pi-plus"
          className="p-button-success mr-2"
          onClick={this.handleShow}
        >
          <Icon.Plus /> Add MarketPlace{" "}
        </Button>
      </React.Fragment>
    );
  }
  // Datatable end
  // Edit Click Button Start
  EditClickButton = (rowData) => {
    if (rowData) {
      this.setState({
        ID: rowData._id,
        categoryValue: rowData.Category,
        subCategoryValue: rowData.SubCategory,
        divisionValue: rowData.Division,
        ProductName: rowData.ProductName,
        MarketURL: rowData.MarketURL,
        ProductLogo: rowData.ProductLogo,
        CompanyName: rowData.CompanyName,
        ProductTagLine: rowData.ProductTagLine,
        ProductSummaryTitle: rowData.ProductSummaryTitle,
        ProductSummary: rowData.ProductSummary,
        ProductDetailsTitle: rowData.ProductDetailsTitle,
        ProductDetails: rowData.ProductDetails,
        IsFeatured: rowData.IsFeatured,
        IsRecommended: rowData.IsRecommended,
        ProductWebsiteLink: rowData.ProductWebsiteLink,
        TagTitle: rowData.TagTitle,
        ProductTags: rowData.ProductTags,
        ProductVideoLinks: rowData.ProductVideoLinks,
        ProductHighlightsTitle: rowData.ProductHighlightsTitle,
        ProductHighlights1: rowData.ProductHighlights1,
        ProductHighlights2: rowData.ProductHighlights2,
        ProductHighlights3: rowData.ProductHighlights3,
        SeoMetaTitle: rowData.SeoMetaTitle,
        SeoMetaDescription: rowData.SeoMetaDescription,
        SeoMetaTags: rowData.SeoMetaTags,
        KeyInfoTitle: rowData.KeyInfoTitle,
        MobileApp: rowData.MobileApp,
        FreeTrialPeriod: rowData.FreeTrialPeriod,
        EligibleforSingapore: rowData.EligibleforSingapore,
        FreeVersion: rowData.FreeVersion,
        MinPriceUserPerMonth: rowData.MinPriceUserPerMonth,
        ContactName: rowData.ContactName,
        Designation: rowData.Designation,
        Email: rowData.Email,
        ContactNumber: rowData.ContactNumber,
        ContactMobileNumber: rowData.ContactMobileNumber,
        HeadquarterAddress: rowData.HeadquarterAddress,
        State: rowData.State,
        City: rowData.City,
        Country: rowData.Country,
        Pincode: rowData.Pincode,
        AdditionalContactNumber: rowData.AdditionalContactNumber,
        AdditionalBranchAddress: rowData.AdditionalBranchAddress,
        ProductBrochure: rowData.ProductBrochure,
        SocialShareImage: rowData.SocialShareImage,
        file: rowData.ProductImages,
        status: null,
        show: true,
      });
    }
  };
  // Edit Click Button End

  // Delete click button start
  DeleteClickButton = (id) => {
    if (id) {
      this.setState({
        ID: id,
        Deletemodal: true,
      });
    }
  };
  // Delete click button end

  // Status click button start
  StatusClickButton = (id, status) => {
    if (id) {
      this.setState({
        ID: id,
        status: status,
        Statusmodal: true,
      });
    }
  };
  // Delete click button end

  // Onchange Start
  //   category
//  categoryonChange = (event) => {
//    if (event) {
//      this.setState({
//        categoryValue: event,
//      });
//      console.log("test", event);
//      event.map((Cateitems) => {
//        axios
//          .post(`${APIKEY}/SubCategory/list`, { Category: Cateitems.value })
//          .then((res) => {
//            const Subcat = res.data;
//            const ARRSUB = [];
//            if (Subcat) {
//              Subcat.map((SubItems) => {
//                const datas = {
//                  value: SubItems._id,
//                  label: SubItems.SubCategoryName,
//                };
//                console.log("test 111", datas);
//                ARRSUB.push(datas);
//              });
//            }
//            this.setState({
//              SubCategorydata: ARRSUB,
//            });
//            console.log("data", res.data);
//          })
//          .catch((e) => {
//            console.log(e);
//          });
//      });
//    }
//  };


  categoryonChange = (event) => {
    if (event) {
      this.setState({ categoryValue: event });
  
      // Array to store promises for each API call
      const promises = event.map((Cateitems) =>
        axios.post(`${APIKEY}/SubCategory/list`, { Category: Cateitems.value })
      );
  
      // Wait for all API calls to complete
      Promise.all(promises)
        .then((responses) => {
          const ARRSUB = [];
  
          responses.forEach((res, index) => {
            const Subcat = res.data;
  
            // Log the response to check if all data is received
            // console.log(`API Response for Category ${event[index].value}:`, Subcat);
  
            if (Subcat && Array.isArray(Subcat)) {
              Subcat.map((SubItems) => {
                const datas = {
                  value: SubItems._id,
                  label: SubItems.SubCategoryName,
                };
                // console.log("Subcategory Data:", datas);
                ARRSUB.push(datas);
              });
            } else {
              // console.warn(`No Subcategories found for Category ${event[index].value}`);
            }
          });
  
          // Update state once after all responses are processed
          this.setState({ SubCategorydata: ARRSUB });
        })
        .catch((error) => {
          console.error("Error fetching subcategories:", error);
        });
    }
  };

  subCategoryChange = (event) => {
    if (event) {
      this.setState({
        subCategoryValue: event,
      });

      event.map((Subcates) => {
        axios
          .post(`${APIKEY}/Division/SubCategory`, {
            SubCategory: Subcates.value,
          })
          .then((res) => {
            const Division = res.data;

            const ARRDIVIS = [];
            if (Division) {
              Division.map((DivItem) => {
                const datas = {
                  value: DivItem._id,
                  label: DivItem.DivisionName,
                };
                ARRDIVIS.push(datas);
              });
            }
            this.setState({
              Divisiondata: ARRDIVIS,
            });
          })
          .catch((e) => {
            console.log(e);
          });
      });
    }
  };
  divisionChange = (event) => {
    if (event) {
      this.setState({
        divisionValue: event,
      });
    }
  };
  onChangeMarketplace = ({ target: { name, value } }) => {
    this.setState({
      [name]: value,
    });
    console.log("onchnage", value);
  };
  //
  handleChangeProductImage = async (e) => {
    const file = e.target.files[0];
    const MIN_FILE_SIZE = 1024; // 1MB

    const fileSizeKiloBytes = file.size / MIN_FILE_SIZE;
    if (fileSizeKiloBytes > MIN_FILE_SIZE) {
      alert("File size is less than minimum limit");
      return;
    }

    this.setState({
      ProductLogo: file,
    });
  };
  handleChangeProductBrochure = async (e) => {
    const file = e.target.files[0];
    const MIN_FILE_SIZE = 5120; // 1MB

    const fileSizeKiloBytes = file.size / MIN_FILE_SIZE;
    if (fileSizeKiloBytes > MIN_FILE_SIZE) {
      alert("you have exceeded the size limit please upload blow 5 MB");
      return;
    }

    this.setState({
      ProductBrochure: file,
    });
  };
  handleChangeAuthorProfileImage = async (e) => {
    const file = e.target.files[0];
    this.setState({
      AuthorProfileImage: file,
    });
  };
  onChangeSocialShareImage = async (e) => {
    const file = e.target.files[0];
    this.setState({
      SocialShareImage: file,
    });
  };
  handleChangeProductDetails = (value) => {
    this.setState({
      ProductDetails: value,
    });
  };
  inputChange = (index, event) => {
    const image = event.target.files[0];

    const MIN_FILE_SIZE = 1024; // 1MB

    const fileSizeKiloBytes = image.size / MIN_FILE_SIZE;
    if (fileSizeKiloBytes > MIN_FILE_SIZE) {
      alert("File size is less than minimum limit");
      return;
    }

    const values = [...this.state.file];
    values[index] = event.target.files[0];

    this.setState({
      file: values,
    });
  };
  addInputs = () => {
    const values = [...this.state.file, ""];
    values.push();
    this.setState({
      file: values,
    });
  };

  removeInput = (i, e) => {
    const values = [...this.state.file];
    if (values.length > -1) {
      values.splice(i, 1);
      this.setState({
        file: values,
      });
    }
  };

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, snapshot) {}

  handleShow = (event) => {
    this.setState({
      show: true,
    });
  };
  ModelClose = (event) => {
    this.setState({
      ID: "",
      categoryValue: [],
      subCategoryValue: [],
      divisionValue: [],
      Category: "",
      SubCategory: "",
      Division: "",
      ProductName: "",
      MarketURL: "",
      ProductLogo: "",
      CompanyName: "",
      ProductTagLine: "",

      ProductSummary: "",

      ProductDetails: "",
      IsFeatured: "",
      IsRecommended: "",
      ProductWebsiteLink: "",

      ProductTags: "",
      ProductVideoLinks: "",

      ProductHighlights1: "",
      ProductHighlights2: "",
      ProductHighlights3: "",
      SeoMetaTitle: "",
      SeoMetaDescription: "",
      SeoMetaTags: "",

      MobileApp: "",
      FreeTrialPeriod: "",
      EligibleforSingapore: "",
      FreeVersion: "",
      MinPriceUserPerMonth: "",
      ContactName: "",
      Designation: "",
      Email: "",
      ContactNumber: "",
      ContactMobileNumber: "",
      HeadquarterAddress: "",
      State: "",
      City: "",
      Country: "",
      Pincode: "",
      AdditionalContactNumber: "",
      AdditionalBranchAddress: "",
      ProductImages: "",
      ProductBrochure: "",
      SocialShareImage: "",
      file: [],
      status: null,
      show: false,
    });
  };

  DeleteModelClose = (event) => {
    this.setState({
      ID: "",
      Deletemodal: false,
    });
  };
  StatusModelClose = (event) => {
    this.setState({
      ID: "",
      status: "",
      Statusmodal: false,
    });
  };
  // editor events

  getSunEditorInstance = (sunEditor) => {
    this.editor.current = sunEditor;
  };
  // Blog Submit
  MarketPlaceSubmit = (event) => {
    event.preventDefault();
    if (this.state.ID) {
      this.EditMarkplaceSubmit(this.state.ID);
    } else {
      this.AddMarketplaceSubmit();
    }
  };

  AddMarketplaceSubmit = (event) => {
    var i = 0;
    const formData = new FormData();

    formData.append("Category", JSON.stringify(this.state.categoryValue));
    formData.append("SubCategory", JSON.stringify(this.state.subCategoryValue));
    formData.append("Division", JSON.stringify(this.state.divisionValue));
    formData.append("ProductName", this.state.ProductName);
    formData.append("MarketURL", this.state.MarketURL);
    formData.append("CompanyName", this.state.CompanyName);
    formData.append("ProductTagLine", this.state.ProductTagLine);
    formData.append("ProductTags", this.state.ProductTags);
    formData.append("ProductSummaryTitle", this.state.ProductSummaryTitle);
    formData.append("ProductSummary", this.state.ProductSummary);
    formData.append("ProductDetailsTitle", this.state.ProductDetailsTitle);
    formData.append("ProductDetails", this.state.ProductDetails);
    formData.append("IsFeatured", this.state.IsFeatured);
    formData.append("IsRecommended", this.state.IsRecommended);
    formData.append("ProductWebsiteLink", this.state.ProductWebsiteLink);
    formData.append("TagTitle", this.state.TagTitle);
    formData.append("ProductVideoLinks", this.state.ProductVideoLinks);
    formData.append(
      "ProductHighlightsTitle",
      this.state.ProductHighlightsTitle
    );
    formData.append("ProductHighlights1", this.state.ProductHighlights1);
    formData.append("ProductHighlights2", this.state.ProductHighlights2);
    formData.append("ProductHighlights3", this.state.ProductHighlights3);
    formData.append("SeoMetaTitle", this.state.SeoMetaTitle);
    formData.append("SeoMetaDescription", this.state.SeoMetaDescription);
    formData.append("SeoMetaTags", this.state.SeoMetaTags);
    formData.append("KeyInfoTitle", this.state.KeyInfoTitle);
    formData.append("MobileApp", this.state.MobileApp);
    formData.append("FreeTrialPeriod", this.state.FreeTrialPeriod);
    formData.append("EligibleforSingapore", this.state.EligibleforSingapore);
    formData.append("FreeVersion", this.state.FreeVersion);
    formData.append("MinPriceUserPerMonth", this.state.MinPriceUserPerMonth);
    formData.append("Designation", this.state.Designation);
    formData.append("Email", this.state.Email);
    formData.append("ContactName", this.state.ContactName);
    formData.append("ContactNumber", this.state.ContactNumber);
    formData.append("ContactMobileNumber", this.state.ContactMobileNumber);
    formData.append("HeadquarterAddress", this.state.HeadquarterAddress);
    formData.append("State", this.state.State);
    formData.append("City", this.state.City);
    formData.append("Country", this.state.Country);
    formData.append("Pincode", this.state.Pincode);
    formData.append(
      "AdditionalContactNumber",
      this.state.AdditionalContactNumber
    );
    formData.append(
      "AdditionalBranchAddress",
      this.state.AdditionalBranchAddress
    );
    formData.append("ProductLogo", this.state.ProductLogo);
    for (i = 0; i < this.state.file.length; i++) {
      formData.append("ProductImages", this.state.file[i]);
    }
    formData.append("ProductBrochure", this.state.ProductBrochure);
    formData.append("SocialShareImage", this.state.SocialShareImage);
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    axios
      .post(`${APIKEY}/MarketPlace`, formData, config)
      .then((res) => {
        if (res.data) {
          console.log("test ok");
          this.getAll();
          this.ModelClose();
          this.toast.show({
            severity: "success",
            summary: "Successful",
            detail: "Marketplace Data",
            life: 3000,
          });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  EditMarkplaceSubmit = (id) => {
    if (id) {
      var i = 0;
      const formData = new FormData();

      formData.append("Category", JSON.stringify(this.state.categoryValue));
      formData.append(
        "SubCategory",
        JSON.stringify(this.state.subCategoryValue)
      );
      formData.append("Division", JSON.stringify(this.state.divisionValue));
      formData.append("ProductName", this.state.ProductName);
      formData.append("MarketURL", this.state.MarketURL);
      formData.append("CompanyName", this.state.CompanyName);
      formData.append("ProductTagLine", this.state.ProductTagLine);
      formData.append("ProductTags", this.state.ProductTags);
      formData.append("ProductSummaryTitle", this.state.ProductSummaryTitle);
      formData.append("ProductSummary", this.state.ProductSummary);
      formData.append("ProductDetailsTitle", this.state.ProductDetailsTitle);
      formData.append("ProductDetails", this.state.ProductDetails);
      formData.append("IsFeatured", this.state.IsFeatured);
      formData.append("IsRecommended", this.state.IsRecommended);
      formData.append("ProductWebsiteLink", this.state.ProductWebsiteLink);
      formData.append("TagTitle", this.state.TagTitle);
      formData.append("ProductVideoLinks", this.state.ProductVideoLinks);
      formData.append(
        "ProductHighlightsTitle",
        this.state.ProductHighlightsTitle
      );
      formData.append("ProductHighlights1", this.state.ProductHighlights1);
      formData.append("ProductHighlights2", this.state.ProductHighlights2);
      formData.append("ProductHighlights3", this.state.ProductHighlights3);
      formData.append("SeoMetaTitle", this.state.SeoMetaTitle);
      formData.append("SeoMetaDescription", this.state.SeoMetaDescription);
      formData.append("SeoMetaTags", this.state.SeoMetaTags);
      formData.append("KeyInfoTitle", this.state.KeyInfoTitle);
      formData.append("MobileApp", this.state.MobileApp);
      formData.append("FreeTrialPeriod", this.state.FreeTrialPeriod);
      formData.append("EligibleforSingapore", this.state.EligibleforSingapore);
      formData.append("FreeVersion", this.state.FreeVersion);
      formData.append("MinPriceUserPerMonth", this.state.MinPriceUserPerMonth);
      formData.append("Designation", this.state.Designation);
      formData.append("Email", this.state.Email);
      formData.append("ContactName", this.state.ContactName);
      formData.append("ContactNumber", this.state.ContactNumber);
      formData.append("ContactMobileNumber", this.state.ContactMobileNumber);
      formData.append("HeadquarterAddress", this.state.HeadquarterAddress);
      formData.append("State", this.state.State);
      formData.append("City", this.state.City);
      formData.append("Country", this.state.Country);
      formData.append("Pincode", this.state.Pincode);
      formData.append(
        "AdditionalContactNumber",
        this.state.AdditionalContactNumber
      );
      formData.append(
        "AdditionalBranchAddress",
        this.state.AdditionalBranchAddress
      );
      formData.append("ProductLogo", this.state.ProductLogo);
      for (i = 0; i < this.state.file.length; i++) {
        formData.append("ProductImages", this.state.file[i]);
      }
      formData.append("ProductBrochure", this.state.ProductBrochure);
      formData.append("SocialShareImage", this.state.SocialShareImage);
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      axios
        .put(`${APIKEY}/MarketPlace/${id}`, formData, config)
        .then((res) => {
          if (res.data) {
            console.log("Update okkk");
            this.getAll();
            this.ModelClose();
            this.toast.show({
              severity: "success",
              summary: "Update Successful",
              detail: "Marketplace Data",
              life: 3000,
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };
  // Delete Blog Data
  DeleteMarketPlacedata = (event) => {
    if (this.state.ID) {
      axios
        .put(`${APIKEY}/MarketPlace/delete/${this.state.ID}`)
        .then((res) => {
          this.getAll();
          this.setState({
            Deletemodal: false,
          });
          this.toast.show({
            severity: "success",
            summary: "Successful",
            detail: "Marketplace Data Delete",
            life: 3000,
          });
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };
  // Blog Status Submit
  // Blog Status Submit
  StatusSubmit = (event) => {
    if (this.state.ID) {
      event.preventDefault();
      const formData = new FormData();
      formData.append("isActive", this.state.status);
      console.log(this.state.status, "this.state.status");
      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      axios
        .put(`${APIKEY}/MarketPlace/status/${this.state.ID}`, formData, config)
        .then((res) => {
          if (res.data) {
            console.log("Update okkk");
            this.getAll();
            this.StatusModelClose();
            this.toast.show({
              severity: "success",
              summary: "Successful",
              detail: "Marketplace Status",
              life: 3000,
            });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  render() {
    const header1 = this.renderHeader1();
    if (this.state.MarketPlacedata.length < 0) {
      this.setState({
        loading1: false,
      });
    }

    return (
      <>
        <div className="container-fluid">
          <Toast ref={(el) => (this.toast = el)} />

          {/* Modal */}
          <Modal
            show={this.state.show}
            fullscreen={this.state.fullscreen}
            onHide={this.ModelClose}
          >
            <Modal.Header closeButton>
              <Modal.Title>Add MarketPlace</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <Container>
                  <Form onSubmit={this.MarketPlaceSubmit}>
                    <Row>
                      <Col md={6}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Select Category</Form.Label>
                          <Select
                            options={this.state.Categorydata}
                            value={this.state.categoryValue}
                            onChange={this.categoryonChange}
                            isMulti
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Select Subcategory</Form.Label>
                          <Select
                            options={this.state.SubCategorydata}
                            value={this.state.subCategoryValue}
                            onChange={this.subCategoryChange}
                            isMulti
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Select Division</Form.Label>
                          <Select
                            options={this.state.Divisiondata}
                            value={this.state.divisionValue}
                            onChange={this.divisionChange}
                            isMulti
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Product Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="ProductName"
                            value={this.state.ProductName}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                            required
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Product URL</Form.Label>
                          <Form.Control
                            type="text"
                            name="MarketURL"
                            value={this.state.MarketURL}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Product Logo</Form.Label>
                          <Form.Control
                            type="file"
                            name=""
                            onChange={this.handleChangeProductImage}
                            placeholder=""
                          />
                        </Form.Group>
                        {this.state.ID && this.state.ProductLogo ? (
                          <>
                            {this.state.ProductLogo.size ? (
                              <>
                                <img
                                  className="rounded"
                                  src={URL.createObjectURL(
                                    this.state.ProductLogo
                                  )}
                                  width={100}
                                  alt="dfgh"
                                />
                                <Button
                                  variant="danger"
                                  onClick={() => {
                                    this.setState({ ProductLogo: "" });
                                  }}
                                >
                                  <Icon.TrashFill />
                                </Button>
                              </>
                            ) : (
                              <>
                                <img
                                  src={`${APIKEY}/Blog_image/${this.state.ProductLogo}`}
                                  className="rounded"
                                  width={100}
                                />
                                <Button
                                  variant="danger"
                                  onClick={() => {
                                    this.setState({ ProductLogo: "" });
                                  }}
                                >
                                  <Icon.TrashFill />
                                </Button>
                              </>
                            )}
                          </>
                        ) : null}
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Company Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="CompanyName"
                            value={this.state.CompanyName}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Product Tag Line</Form.Label>
                          <Form.Control
                            type="text"
                            name="ProductTagLine"
                            value={this.state.ProductTagLine}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Product Summary Title</Form.Label>
                          <Form.Control
                            type="text"
                            name="ProductSummaryTitle"
                            value={this.state.ProductSummaryTitle}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                            readOnly
                            disabled
                          />
                        </Form.Group>
                      </Col>

                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Product Summary</Form.Label>
                          <Form.Control
                            type="text"
                            name="ProductSummary"
                            value={this.state.ProductSummary}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Product Details Title</Form.Label>
                          <Form.Control
                            type="text"
                            name="ProductDetailsTitle"
                            value={this.state.ProductDetailsTitle}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                            readOnly
                            disabled
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Product Website Link</Form.Label>
                          <Form.Control
                            type="text"
                            name="ProductWebsiteLink"
                            value={this.state.ProductWebsiteLink}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Is Featured ?</Form.Label>
                          <Form.Select
                            name="IsFeatured"
                            value={this.state.IsFeatured}
                            onChange={this.onChangeMarketplace}
                          >
                            <option>Choose...</option>
                            <option value={true}>Yes</option>
                            <option value={false}>No</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Is Recommended ?</Form.Label>
                          <Form.Select
                            name="IsRecommended"
                            value={this.state.IsRecommended}
                            onChange={this.onChangeMarketplace}
                          >
                            <option>Choose...</option>
                            <option value={true}>Yes</option>
                            <option value={false}>No</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>

                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Tag Title</Form.Label>
                          <Form.Control
                            type="text"
                            name="TagTitle"
                            value={this.state.TagTitle}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                            readOnly
                            disabled
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Product Brochure</Form.Label>
                          <Form.Control
                            type="file"
                            name=""
                            onChange={this.handleChangeProductBrochure}
                            placeholder=""
                          />
                        </Form.Group>
                        {this.state.ID && this.state.ProductBrochure ? (
                          <>
                            {this.state.ProductBrochure.size ? (
                              <>
                                <img
                                  className="rounded"
                                  src={URL.createObjectURL(
                                    this.state.ProductBrochure
                                  )}
                                  width={100}
                                  alt="dfgh"
                                />
                                <Button
                                  variant="danger"
                                  onClick={() => {
                                    this.setState({ ProductBrochure: "" });
                                  }}
                                >
                                  <Icon.TrashFill />
                                </Button>
                              </>
                            ) : (
                              <>
                                <img
                                  src={`${APIKEY}/Blog_image/${this.state.ProductBrochure}`}
                                  className="rounded"
                                  width={100}
                                />
                                <Button
                                  variant="danger"
                                  onClick={() => {
                                    this.setState({ ProductBrochure: "" });
                                  }}
                                >
                                  <Icon.TrashFill />
                                </Button>
                              </>
                            )}
                          </>
                        ) : null}
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Product Tags</Form.Label>
                          <Form.Control
                            type="text"
                            name="ProductTags"
                            value={this.state.ProductTags}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Product Video Links</Form.Label>
                          <Form.Control
                            type="text"
                            name="ProductVideoLinks"
                            value={this.state.ProductVideoLinks}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Product Highlights Title</Form.Label>
                          <Form.Control
                            type="text"
                            name="ProductHighlightsTitle"
                            value={this.state.ProductHighlightsTitle}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                            readOnly
                            disabled
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Product Highlights 1</Form.Label>
                          <Form.Control
                            type="text"
                            name="ProductHighlights1"
                            value={this.state.ProductHighlights1}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Product Highlights 2</Form.Label>
                          <Form.Control
                            type="text"
                            name="ProductHighlights2"
                            value={this.state.ProductHighlights2}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Product Highlights 3</Form.Label>
                          <Form.Control
                            type="text"
                            name="ProductHighlights3"
                            value={this.state.ProductHighlights3}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Seo Meta Title</Form.Label>
                          <Form.Control
                            type="text"
                            name="SeoMetaTitle"
                            value={this.state.SeoMetaTitle}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Seo Meta Description</Form.Label>
                          <Form.Control
                            type="text"
                            name="SeoMetaDescription"
                            value={this.state.SeoMetaDescription}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>SeoMeta Tags</Form.Label>
                          <Form.Control
                            type="text"
                            name="SeoMetaTags"
                            value={this.state.SeoMetaTags}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Social Share Image</Form.Label>
                          <Form.Control
                            type="file"
                            name="SocialShareImage"
                            onChange={this.onChangeSocialShareImage}
                            placeholder=""
                          />
                        </Form.Group>
                        {this.state.ID && this.state.SocialShareImage ? (
                          <>
                            {this.state.SocialShareImage.size ? (
                              <>
                                <img
                                  className="rounded"
                                  src={URL.createObjectURL(
                                    this.state.SocialShareImage
                                  )}
                                  width={100}
                                  alt="dfgh"
                                />
                                <Button
                                  variant="danger"
                                  onClick={() => {
                                    this.setState({ SocialShareImage: "" });
                                  }}
                                >
                                  <Icon.TrashFill />
                                </Button>
                              </>
                            ) : (
                              <>
                                <img
                                  src={`${APIKEY}/Blog_image/${this.state.SocialShareImage}`}
                                  className="rounded"
                                  width={100}
                                />
                                <Button
                                  variant="danger"
                                  onClick={() => {
                                    this.setState({ SocialShareImage: "" });
                                  }}
                                >
                                  <Icon.TrashFill />
                                </Button>
                              </>
                            )}
                          </>
                        ) : null}
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label> Product Details</Form.Label>
                          <SunEditor
                            getSunEditorInstance={this.getSunEditorInstance}
                            value={this.state.ProductDetails}
                            setContents={this.state.ProductDetails}
                            onChange={this.handleChangeProductDetails}
                            // onImageUploadBefore={handleImageUploadBefore}
                            // onImageUpload={handleImageUpload}
                            placeholder={"Write something awesome..."}
                            setOptions={{
                              buttonList: [
                                ["undo", "redo"],
                                ["font", "fontSize"],
                                ["paragraphStyle", "blockquote"],
                                [
                                  "bold",
                                  "underline",
                                  "italic",
                                  "strike",
                                  "subscript",
                                  "superscript",
                                ],
                                ["fontColor", "hiliteColor"],
                                ["align", "list", "lineHeight"],
                                ["outdent", "indent"],

                                [
                                  "table",
                                  "horizontalRule",
                                  "link",
                                  "image",
                                  "video",
                                ],
                                // ['math'] //You must add the 'katex' library at options to use the 'math' plugin.
                                ["imageGallery"], // You must add the "imageGalleryUrl".
                                ["fullScreen", "showBlocks", "codeView"],
                                ["preview", "print"],
                                ["removeFormat"],

                                // ['save', 'template'],
                                // '/', Line break
                              ], // Or Array of button list, eg. [['font', 'align'], ['image']]
                            }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="row ml-2 mr-2">
                      <Form.Group
                        className="mb-3 row"
                        controlId="exampleForm.ControlInput1"
                      >
                        <Form.Label>Product Images</Form.Label>

                        {this.state.file?.map((data, idx) => {
                          return (
                            <>
                              <Col md={3} key={idx}>
                                <div className="form-group d-flex">
                                  <Form.Control
                                    type="file"
                                    name="vals"
                                    className="form-control"
                                    onChange={(event) =>
                                      this.inputChange(idx, event)
                                    }
                                  />
                                  <button
                                    className="btn btn-danger border-0 pl-2 pr-2 ml-1"
                                    style={btnStyle}
                                    type="button"
                                    onClick={(e) => this.removeInput(idx, e)}
                                  >
                                    X
                                  </button>
                                </div>
                                {this.state.ID && this.state.file.length > 0 ? (
                                  <>
                                    <div>
                                      <img
                                        src={`${APIKEY}/MarketPlace_image/${data}`}
                                        className="rounded"
                                        width={100}
                                      ></img>
                                    </div>
                                  </>
                                ) : null}
                              </Col>
                            </>
                          );
                        })}
                        <div className="form-group col">
                          <button
                            className="btn btn-outline-success"
                            type="button"
                            onClick={this.addInputs}
                          >
                            Add
                          </button>
                        </div>
                      </Form.Group>
                    </Row>
                    <hr></hr>
                    <Row>
                      <h3>Key Info</h3>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Key Info Title</Form.Label>
                          <Form.Control
                            type="text"
                            name="KeyInfoTitle"
                            value={this.state.KeyInfoTitle}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                            readOnly
                            disabled
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Mobile App</Form.Label>
                          <Form.Select
                            name="MobileApp"
                            value={this.state.MobileApp}
                            onChange={this.onChangeMarketplace}
                          >
                            <option>Choose...</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Free Trial Period</Form.Label>
                          <Form.Select
                            name="FreeTrialPeriod"
                            value={this.state.FreeTrialPeriod}
                            onChange={this.onChangeMarketplace}
                          >
                            <option>Choose...</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Eligible for Singapore Govt</Form.Label>
                          <Form.Select
                            name="EligibleforSingapore"
                            value={this.state.EligibleforSingapore}
                            onChange={this.onChangeMarketplace}
                          >
                            <option>Choose...</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Free Version</Form.Label>
                          <Form.Select
                            name="FreeVersion"
                            value={this.state.FreeVersion}
                            onChange={this.onChangeMarketplace}
                          >
                            <option>Choose...</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>
                            Min. Price/User Per Month (Inr)
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="MinPriceUserPerMonth"
                            value={this.state.MinPriceUserPerMonth}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                    <hr></hr>
                    <Row>
                      <h3>Product Contacts</h3>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Contact Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="ContactName"
                            value={this.state.ContactName}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Designation</Form.Label>
                          <Form.Control
                            type="text"
                            name="Designation"
                            value={this.state.Designation}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            type="email"
                            name="Email"
                            value={this.state.Email}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Contact Number</Form.Label>
                          <Form.Control
                            type="number"
                            name="ContactNumber"
                            value={this.state.ContactNumber}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Contact Mobile Number</Form.Label>
                          <Form.Control
                            type="number"
                            name="ContactMobileNumber"
                            value={this.state.ContactMobileNumber}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlTextarea1"
                        >
                          <Form.Label>Headquarter Address</Form.Label>
                          <Form.Control
                            as="textarea"
                            name="HeadquarterAddress"
                            value={this.state.HeadquarterAddress}
                            onChange={this.onChangeMarketplace}
                            rows={3}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>State</Form.Label>
                          <Form.Control
                            type="text"
                            name="State"
                            value={this.state.State}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>City</Form.Label>
                          <Form.Control
                            type="text"
                            name="City"
                            value={this.state.City}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Country </Form.Label>
                          <Form.Control
                            type="text"
                            name="Country"
                            value={this.state.Country}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Pincode </Form.Label>
                          <Form.Control
                            type="number"
                            name="Pincode"
                            value={this.state.Pincode}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlInput1"
                        >
                          <Form.Label>Additional Contact Number </Form.Label>
                          <Form.Control
                            type="number"
                            name="AdditionalContactNumber"
                            value={this.state.AdditionalContactNumber}
                            onChange={this.onChangeMarketplace}
                            placeholder=""
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group
                          className="mb-3"
                          controlId="exampleForm.ControlTextarea1"
                        >
                          <Form.Label>Additional Branch Address</Form.Label>
                          <Form.Control
                            as="textarea"
                            name="AdditionalBranchAddress"
                            value={this.state.AdditionalBranchAddress}
                            onChange={this.onChangeMarketplace}
                            rows={3}
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <div className="d-flex justify-content-end">
                        <br></br>
                        <Button
                          variant="danger"
                          className="me-2"
                          onClick={this.ModelClose}
                        >
                          Cancel
                        </Button>
                        <Button variant="primary" type="submit">
                          {this.state.ID ? "Update" : "Submit"}
                        </Button>
                      </div>
                    </Row>
                  </Form>
                </Container>
              </div>
            </Modal.Body>
          </Modal>
          {/* Modal end */}
          <div>
            {/* Datatable start*/}

            <Toolbar
              className="mb-4"
              left={this.leftToolbarTemplate}
              right={this.rightToolbarTemplate}
            ></Toolbar>

            <DataTable
              value={this.state.MarketPlacedata}
              ref={(el) => (this.dt = el)}
              size="small"
              paginator
              scrollable
              scrollHeight="400px"
              className="p-datatable-customers"
              showGridlines
              rows={10}
              dataKey="id"
              filters={this.state.filters1}
              filterDisplay="menu"
              loading={this.state.loading1}
              responsiveLayout="scroll"
              globalFilterFields={["ProductName", "Blogurlname"]}
              header={header1}
              emptyMessage="No Marketplace data found"
            >
              <Column
                field="ProductName"
                header="Product Name"
                alignFrozen="left"
                frozen={this.state.balanceFrozen}
                style={{ minWidth: "12rem" }}
              />
              <Column
                field="MarketURL"
                header="Product Url"
                style={{ minWidth: "0px " }}
              />
              <Column
                field="CompanyName"
                header="Company Name"
                style={{ minWidth: "0px " }}
              />
              <Column
                field="BlogShortDescription"
                header="Status"
                body={this.BlogStatus}
                style={{ minWidth: "0px " }}
              />

              <Column
                field="activity"
                header="Activity"
                showFilterMatchModes={false}
                alignFrozen="right"
                frozen={this.state.balanceFrozen}
                style={{ minWidth: "6rem" }}
                body={this.activityBodyTemplate}
              />
            </DataTable>
            {/* Datatable end*/}

            {/* Delete data modal start */}
            <Modal
              show={this.state.Deletemodal}
              onHide={this.DeleteModelClose}
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                  Delete
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <h4>Do you want delete this data ?</h4>
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={this.DeleteModelClose}>No</Button>
                <Button variant="danger" onClick={this.DeleteMarketPlacedata}>
                  Yes
                </Button>
              </Modal.Footer>
            </Modal>
            {/* Delete data modal end */}
            {/* Status data modal start */}
            <Modal
              show={this.state.Statusmodal}
              onHide={this.StatusModelClose}
              size="md"
              aria-labelledby="contained-modal-title-vcenter"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                  Status
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form onSubmit={this.StatusSubmit}>
                  <Row>
                    <Col md={12}>
                      <Form.Group as={Row} className="mb-3">
                        <Form.Label as="legend" column sm={2}>
                          Status
                        </Form.Label>
                        <Col sm={10}>
                          <Form.Check
                            type="radio"
                            label="Active"
                            name="status"
                            value={true}
                            onChange={this.onChangeMarketplace}
                            id="formHorizontalRadios1"
                          />
                          <Form.Check
                            type="radio"
                            label="Inactive"
                            name="status"
                            value={false}
                            onChange={this.onChangeMarketplace}
                            id="formHorizontalRadios2"
                          />
                        </Col>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <div className="d-flex justify-content-end">
                      <br></br>

                      <Button
                        variant="danger"
                        className="me-2"
                        onClick={this.StatusModelClose}
                      >
                        Cancel
                      </Button>
                      <Button variant="primary" type="submit">
                        Submit
                      </Button>
                    </div>
                  </Row>
                </Form>
              </Modal.Body>
            </Modal>
            {/* Status data modal end */}
          </div>
        </div>
      </>
    );
  }
}
export default MarketPlace;
